export const saveOriginalName = (location: string) => {
  sessionStorage.setItem('originalLocationName', JSON.stringify(location));
};
